import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { jobCostKeys } from "@/lib/query";

interface JobCost {
  id: string;
  projectId: string;
  costCode: string | null;
  description: string | null;
  budgetAmount: string | null;
  committedAmount: string | null;
  actualAmount: string | null;
  variance: string | null;
}

export type { JobCost };

export function useJobCosts(projectId?: string) {
  return useQuery({
    queryKey: [...jobCostKeys.all, projectId],
    queryFn: () =>
      apiFetch<JobCost[]>(projectId ? `/job-costs?projectId=${projectId}` : "/job-costs"),
  });
}
